import type { JSX } from 'react';

interface Props {
    className?: string;
    /** Sets both width and height — square. */
    size?: string | number;
    /** When set without `size`, height is fixed and width auto-scales to the
     *  glyph's native 20:9.17 aspect ratio. */
    height?: string | number;
    color?: string;
}

// Native aspect ratio of the viewBox (20 / 9.16667).
const INFINITY_ASPECT = 20 / 9.16667;

export const CustomInfinity = ({ className, size, height, color = 'currentColor' }: Props): JSX.Element => {
    const heightValue = height ?? size;
    const heightStyle = typeof heightValue === 'number' ? `${heightValue}px` : heightValue;
    // When only `height` is given, compute width from the native aspect ratio
    // (Satori doesn't accept `width: 'auto'`).
    const widthStyle =
        height !== undefined && typeof height === 'number'
            ? `${Math.round(height * INFINITY_ASPECT)}px`
            : typeof size === 'number'
              ? `${size}px`
              : size;
    return (
        <svg
            viewBox="0 0 20 9.16667"
            className={className}
            style={{
                width: widthStyle || 'inherit',
                height: heightStyle || 'inherit',
                display: 'flex',
                overflow: 'visible',
                verticalAlign: 'middle',
            }}
            fill="none"
        >
            <path
                d="M4.58333 9.16667C3.30556 9.16667 2.22222 8.72222 1.33333 7.83333C0.444444 6.94445 0 5.86111 0 4.58333C0 3.30556 0.444444 2.22222 1.33333 1.33333C2.22222 0.444444 3.30556 0 4.58333 0C5.09722 0 5.59028 0.0902778 6.0625 0.270833C6.53472 0.451389 6.95833 0.708333 7.33333 1.04167L8.75 2.33333L7.5 3.45833L6.20833 2.29167C5.98611 2.09722 5.73611 1.94444 5.45833 1.83333C5.18056 1.72222 4.88889 1.66667 4.58333 1.66667C3.77778 1.66667 3.09028 1.95139 2.52083 2.52083C1.95139 3.09028 1.66667 3.77778 1.66667 4.58333C1.66667 5.38889 1.95139 6.07639 2.52083 6.64583C3.09028 7.21528 3.77778 7.5 4.58333 7.5C4.88889 7.5 5.18056 7.44444 5.45833 7.33333C5.73611 7.22222 5.98611 7.06944 6.20833 6.875L12.6667 1.04167C13.0417 0.708333 13.4653 0.451389 13.9375 0.270833C14.4097 0.0902778 14.9028 0 15.4167 0C16.6944 0 17.7778 0.444444 18.6667 1.33333C19.5556 2.22222 20 3.30556 20 4.58333C20 5.86111 19.5556 6.94445 18.6667 7.83333C17.7778 8.72222 16.6944 9.16667 15.4167 9.16667C14.9028 9.16667 14.4097 9.07639 13.9375 8.89583C13.4653 8.71528 13.0417 8.45833 12.6667 8.125L11.25 6.83333L12.5 5.70833L13.7917 6.875C14.0139 7.06944 14.2639 7.22222 14.5417 7.33333C14.8194 7.44444 15.1111 7.5 15.4167 7.5C16.2222 7.5 16.9097 7.21528 17.4792 6.64583C18.0486 6.07639 18.3333 5.38889 18.3333 4.58333C18.3333 3.77778 18.0486 3.09028 17.4792 2.52083C16.9097 1.95139 16.2222 1.66667 15.4167 1.66667C15.1111 1.66667 14.8194 1.72222 14.5417 1.83333C14.2639 1.94444 14.0139 2.09722 13.7917 2.29167L7.33333 8.125C6.95833 8.45833 6.53472 8.71528 6.0625 8.89583C5.59028 9.07639 5.09722 9.16667 4.58333 9.16667Z"
                fill={color}
            />
        </svg>
    );
};
